const PartnerDelegateNoOpRow = ({ index, delegateItem, oddIdx }) => {
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td-sm col text-wrap odd" : "list-td-sm col text-wrap even"}>{(delegateItem.parentCompanyName)? delegateItem.parentCompanyName:""}</td>
			<td className={oddIdx ? "list-td-sm col text-wrap odd" : "list-td-sm col text-wrap even"}>{delegateItem.companyName+ ', ' + (delegateItem.city ? delegateItem.city + ', ' : '') + delegateItem.stateCode + ', ' + delegateItem.countryCode}</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{delegateItem.startDate}</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{delegateItem.endDate}</td>
			<td className={oddIdx ? "list-td-sm col odd" : "list-td-sm col even"}>{delegateItem.status}</td>
		</tr>
	)
}
export default PartnerDelegateNoOpRow;